/**
 * External Dependencies
 */
import React, { useState } from 'react';
import classNames from 'classnames';

/**
 * Internal Dependencies
 */
import Button from 'components/button';
import FormTextInput from 'components/forms/form-text-input';
import FormPasswordInput from 'components/forms/form-password-input';
import FormInputFloatingLabel from 'components/forms/form-input-floating-label';
import Card from 'components/card';
import cecSdk from 'lib/customer-ec-sdk';
import Preloader from 'components/preloader';

/**
 * Style dependencies
 */
import './styles.scss';

const SignInForm = () => {
	const [error, setError] = useState(null);
	const [values, setValues] = useState({ usernameOrEmail: '', password: '' });
	const [submitting, setSubmitting] = useState(false);

	const onSubmitForm = (e) => {
		e.preventDefault();
		loginUser();
	};

	// const loginUser = async (e) => {
	// 	const { usernameOrEmail, password } = values;
	// 	setError(null);
	// 	setSubmitting(true);

	// 	const queryParameters = new URLSearchParams(window.location.search);
	// 	const hmac = queryParameters.get("hmac");
	// 	const host = queryParameters.get("host");
	// 	const shop = queryParameters.get("shop");
	// 	const timestamp = queryParameters.get("timestamp");
	// 	const session = queryParameters.get("session");

	// 	return cecSdk
	// 		.authentication()
	// 		.login(usernameOrEmail, password)
	// 		.then(({ token }) => {
	// 			localStorage.setItem('currentUserJWT', token);
	// 			localStorage.setItem('hmac', hmac);
	// 			localStorage.setItem('host', host);
	// 			localStorage.setItem('shop', shop);
	// 			localStorage.setItem('timestamp', timestamp);
	// 			localStorage.setItem('session', session);

	// 			if(hmac !== null) {
	// 				if(session !== null) {
	// 					const redirect = "/sgc/install?hmac="+hmac+"&host="+host+"&session="+session+"&shop="+shop+"&timestamp="+timestamp;
	// 					window.location = redirect;
	// 				} else {
	// 					const redirect = "/sgc/install?hmac="+hmac+"&host="+host+"&shop="+shop+"&timestamp="+timestamp;
	// 					window.location = redirect;
	// 				}
	// 			} else {
	// 				window.location = '/';
	// 			}
	// 		})
	// 		.catch((error) => {
	// 			setError(error);
	// 			setSubmitting(false);
	// 		});
	// };

	const loginUser = async (e) => {
		const { usernameOrEmail, password } = values;
		setError(null);
		setSubmitting(true);

		const queryParameters = new URLSearchParams(window.location.search);
		const code = queryParameters.get("code");
		const hmac = queryParameters.get("hmac");
		const host = queryParameters.get("host");
		const shop = queryParameters.get("shop");
		const timestamp = queryParameters.get("timestamp");
		const session = queryParameters.get("session");

		return cecSdk
			.authentication()
			.login(usernameOrEmail, password)
			.then(({ token }) => {
				localStorage.setItem('currentUserJWT', token);
				localStorage.setItem('code', code);
				localStorage.setItem('hmac', hmac);
				localStorage.setItem('host', host);
				localStorage.setItem('shop', shop);
				localStorage.setItem('timestamp', timestamp);
				localStorage.setItem('session', session);

				if(hmac !== null && code !== null && shop !== null && timestamp !== null) {
					if(session !== null) {
						const redirect = "/sgc/callback?code="+code+"&hmac="+hmac+"&host="+host+"&session="+session+"&shop="+shop+"&timestamp="+timestamp;
						window.location = redirect;
					} else {
						const redirect = "/sgc/callback?code="+code+"&hmac="+hmac+"&host="+host+"&shop="+shop+"&timestamp="+timestamp;
						window.location = redirect;
					}
				} else {
					window.location = '/';
				}
			})
			.catch((error) => {
				setError(error);
				setSubmitting(false);
			});
	};

	const onChangeField = (e) => {
		const { name, value } = e.target;
		setError(null);
		setValues({ ...values, [name]: value });
	};

	const signinStyles = classNames(['signin__form'], { 'login-form--has-error': !!error });

	return (
		<Card className='login-form'>
			<h3 className='login-form__heading'>Tower Advantage&trade; Login</h3>
			<form className={signinStyles} onSubmit={onSubmitForm}>
				<FormInputFloatingLabel
					label='Username'
					value={values.usernameOrEmail}
					FormInput={FormTextInput}
					name='usernameOrEmail'
					onChange={onChangeField}
				/>
				<FormInputFloatingLabel
					visible={values.visible}
					onChange={onChangeField}
					label='Password'
					name='password'
					value={values.password}
					FormInput={FormPasswordInput}
				/>
				{error && (
					<p className='help-text'>
						Sorry, username or password don't match.
						<br />
						<a href="//towersystems.com.au/login.html?view=reset">Forgot your password?</a>
					</p>
				)}
				<Button className='login-form__submit-btn' primary type='submit'>
					Log in
				</Button>
				<div className='signin-form__links'>
					<a
						className='signin-form__forgot-password'
						href='//towersystems.com.au/login.html?view=reset'
						data-tip='Forgot Password'
						data-for='forgotPassword'
					>
						Forgot your password?
					</a>
				</div>
			</form>
			{submitting && <Preloader />}
		</Card>
	);
};

export default SignInForm;